class WIquickadd extends HTMLElement{
    constructor() {
        super();
    }
    connectedCallback() {
        this.clickOnQuickAdd();
    }
    // Clicking on variant options for adding to cart
    async clickOnQuickAdd() {
        let AddButton = this.querySelectorAll('button');
        let addToCartVariantId;
        AddButton.forEach(btn=>{
            btn.addEventListener('click', async () => {
                btn.style.backgroundColor = '#000';
                btn.querySelector('.WI_valueSpan').style.display = "none";
                btn.querySelector('.WI_loadingSpan').style.display = "block";
                let firstVarTitle = btn.getAttribute('data-id').replace(/\s+/g, '');
                let VarTitle = btn.getAttribute('data-title');
                let parts = firstVarTitle.split("/"); // Split by "/"
                parts[parts.length - 1] = VarTitle;   // Replace the last part with VarTitle
                let resultVarTitle = parts.join("/");  
                let proHandel = btn.getAttribute('data-handel');
                console.log(resultVarTitle);
                let proHandelRes = await fetch('/products/'+proHandel+'.js');
                let proHandelJson = await proHandelRes.json();
                console.log(proHandelJson.variants);
                proHandelJson.variants.forEach(variant => {
                    let handelVariantTitle = variant.title.replace(/\s+/g, '');
                    if (handelVariantTitle == resultVarTitle) {
                        console.log(variant.id);
                        addToCartVariantId = variant.id;
                    }
                });
                try {
                    let formData = {'items': [{'id': addToCartVariantId,'quantity': 1}]};
                    let quickAddRes = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(formData),
                    });
                    document.dispatchEvent(new CustomEvent('updateCart', {bubbles: true}));
                    document.dispatchEvent(new CustomEvent('opencart', {bubbles: true}));
                    btn.style.backgroundColor = '#fff';
                    btn.querySelector('.WI_valueSpan').style.display = "block";
                    btn.querySelector('.WI_loadingSpan').style.display = "none";
                } catch (error) {
                    console.log('Quick add to cart function failed'+ error);
                    
                }  
            });
        }); 
    }
}

customElements.define('wi-quickadd', WIquickadd);